import { createRequestFields, createInitialFormData } from "src/models/common/form_modal";
import { Item } from "./item.model";
import { Pagination } from "src/models/common/table_main";

export interface ItemRequest {
    soldToPT: string;
    materialDescription: string;
    materialCode: string;
    createdBy?: string;
    updatedBy?: string;
  }
  
  export interface SubmitRequest {
    importItems: Array<ItemRequest>;
    userId: string;
  }
  
  export interface ItemState {
    data: Item[] | null;
    pagination: Pagination | null;
    loading: boolean;
    error: boolean;
    errorMessage: string;
  }
  
  export const itemInitialState: ItemState = {
    data: null,
    pagination:null,
    loading: false,
    error: false,
    errorMessage: null,   
  };
  
  // Ini untuk Form Add / Update 
  export const itemRequest = createRequestFields<Item>([
    { label: 'Sold To PT', name: 'soldToPT', dataType: 'string' },
    { label: 'Material Description', name: 'materialDescription', dataType: 'string' },
    { label: 'Material Code', name: 'materialCode', dataType: 'string' },
  ]);
  
  export const initialItemFormData = createInitialFormData<Item>(itemRequest);
  